// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function UnifiedSettingsRecovery(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Alert.$$Error.make, {
        title: "Your settings could not be loaded. Reload to try again."
      }),
      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: param => {
          window.location.reload();
        },
        children: "Reload settings"
      })
    ],
    className: "space-y-4"
  });
}

let make = UnifiedSettingsRecovery;

exports.make = make;
/* Alert Not a pure module */
